'use client';

import Link from 'next/link';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function About() {
  const t = useTranslations('about');

  return (
    <section className="py-20 px-4 bg-section-pink-white">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-navy">{t('title')}</h2>
        <p className="text-lg text-navy/90 leading-relaxed mb-8">{t('teaser')}</p>
        <Link href="/a-propos">
          <Button size="lg" variant="secondary" className="group">
            {t('cta')}
            <ArrowRight className="ml-2 w-5 h-5 inline-block group-hover:translate-x-1 transition-transform" />
          </Button>
        </Link>
      </div>
    </section>
  );
}
